var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystem({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14647_2105)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8711 6.03647L13.4561 5.31641C13.1051 4.70713 12.3271 4.49694 11.717 4.84654V4.84654C11.4266 5.01762 11.08 5.06616 10.7538 4.98145C10.4275 4.89674 10.1484 4.68574 9.97785 4.39498C9.86816 4.21016 9.80922 3.99966 9.80699 3.78475V3.78475C9.81689 3.44021 9.6869 3.10633 9.44664 2.85917C9.20638 2.61202 8.87632 2.47264 8.53163 2.47278H7.69563C7.35794 2.47277 7.03417 2.60734 6.79596 2.84669C6.55775 3.08604 6.42474 3.41046 6.42637 3.74814V3.74814C6.41636 4.44534 5.84828 5.00527 5.151 5.0052C4.9361 5.00296 4.7256 4.94402 4.54078 4.83433V4.83433C3.93067 4.48474 3.1527 4.69492 2.80165 5.3042L2.35619 6.03647C2.00557 6.64499 2.21289 7.42246 2.81996 7.7756V7.7756C3.21456 8.00342 3.45765 8.42445 3.45765 8.8801C3.45765 9.33575 3.21456 9.75678 2.81996 9.9846V9.9846C2.21366 10.3354 2.00611 11.1109 2.35619 11.7176V11.7176L2.77724 12.4438C2.94172 12.7406 3.21769 12.9596 3.54409 13.0524C3.87048 13.1451 4.22039 13.104 4.51637 12.9381V12.9381C4.80735 12.7683 5.15408 12.7218 5.47952 12.8089C5.80495 12.8959 6.08212 13.1094 6.2494 13.4018C6.35909 13.5867 6.41803 13.7972 6.42026 14.0121V14.0121C6.42026 14.7164 6.99126 15.2874 7.69563 15.2874H8.53163C9.23362 15.2874 9.80363 14.7201 9.80699 14.0182V14.0182C9.80536 13.6794 9.9392 13.3541 10.1787 13.1145C10.4183 12.875 10.7436 12.7412 11.0824 12.7428C11.2967 12.7485 11.5064 12.8072 11.6926 12.9137V12.9137C12.3011 13.2643 13.0786 13.057 13.4317 12.4499V12.4499L13.8711 11.7176C14.0411 11.4257 14.0878 11.0781 14.0008 10.7516C13.9137 10.4252 13.7001 10.147 13.4073 9.9785V9.9785C13.1145 9.81003 12.9009 9.53178 12.8138 9.20535C12.7268 8.87893 12.7735 8.53127 12.9435 8.23937C13.0541 8.04628 13.2142 7.88619 13.4073 7.7756V7.7756C14.0107 7.42266 14.2176 6.64972 13.8711 6.04257V6.04257V6.03647Z",
    stroke: "#003056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 8.11669,
    cy: 8.88012,
    r: 1.75744,
    stroke: "#003056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14647_2105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.954102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystem);
export default __webpack_public_path__ + "static/media/system.03aef9a79bf8cc2d5f66017d01cc5592.svg";
export { ForwardRef as ReactComponent };